module.exports = __webpack_public_path__ + "img/one_rows_act.7143047f.svg";